module.exports = __webpack_public_path__ + "static/media/Gandalf.301df9b2.jpg";